import { apiClient } from "../api/ApiClient";


export const fetchAllUsers= ()=> 
    apiClient.get('/api/users/list',{})
export const fetchUserAddresses= ()=> 
    apiClient.get(`/api/addresses`)
export const addAddressToUser= (body)=>
    apiClient.post(`/api/addresses`,body);
export const setAddressAsDefault = (addressId) =>
    apiClient.post(`/api/addresses/${addressId}/set-default`);
export const deleteAddressById= (addressId)=>
    apiClient.delete(`/api/addresses/${addressId}`)
export const updateUserProfile= (userId, data)=>
    apiClient.put(`/api/users/${userId}/update-profile`, data)
export const getUserLocationByLatAndLong= async (latitude, longitude)=>
    apiClient.get(`/api/location/reverse?lat=${latitude}&lon=${longitude}`)